(() => {
  const root = window;

  function createArticleDetail() {
    return {
      activeTocIndex: 0,
      panels: {
        toc: true,
        topics: false
      },
      scrollHandler: null,
      tocItems: [],
      tocTargets: [],
      updateActiveFrame: null,

      init() {
        this.$nextTick(() => {
          this.prepareTableOfContents();
          this.updateActiveToc();

          this.scrollHandler = this.handleScroll.bind(this);
          root.addEventListener('scroll', this.scrollHandler, { passive: true });
        });
      },

      destroy() {
        if (this.scrollHandler) {
          root.removeEventListener('scroll', this.scrollHandler);
        }

        if (this.updateActiveFrame) {
          root.cancelAnimationFrame(this.updateActiveFrame);
        }
      },

      handleScroll() {
        if (this.updateActiveFrame) {
          return;
        }

        this.updateActiveFrame = root.requestAnimationFrame(() => {
          this.updateActiveFrame = null;
          this.updateActiveToc();
        });
      },

      createHeadingId(label, index) {
        const sectionId = this.$root.dataset.articleSectionId;
        const slug = label
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLocaleLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');
        const baseId = `article-section-${sectionId}-${slug || index + 1}`;
        let headingId = baseId;
        let duplicateIndex = 2;

        while (root.document.getElementById(headingId)) {
          headingId = `${baseId}-${duplicateIndex}`;
          duplicateIndex += 1;
        }

        return headingId;
      },

      prepareTableOfContents() {
        if (!this.$refs.articleContent) {
          return;
        }

        const headings = Array.from(this.$refs.articleContent.querySelectorAll('h2, h3')).filter((heading) => {
          return heading.textContent.trim().length > 0;
        });

        this.tocTargets = headings;
        this.tocItems = headings.map((heading, index) => {
          const label = heading.textContent.trim();

          heading.id = heading.id || this.createHeadingId(label, index);

          return {
            id: heading.id,
            label,
            level: Number(heading.tagName.slice(1))
          };
        });

        const hashTargetIndex = this.tocTargets.findIndex((heading) => heading && `#${heading.id}` === root.location.hash);

        if (hashTargetIndex >= 0) {
          this.activeTocIndex = hashTargetIndex;
          this.tocTargets[hashTargetIndex].scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      },

      scrollToSection(index) {
        const target = this.tocTargets[index];

        if (!target) {
          return;
        }

        this.activeTocIndex = index;

        if (root.location.hash !== `#${target.id}`) {
          root.history.pushState(null, '', `#${target.id}`);
        }

        target.scrollIntoView({
          behavior: root.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      },

      togglePanel(panel) {
        if (Object.prototype.hasOwnProperty.call(this.panels, panel)) {
          this.panels[panel] = !this.panels[panel];
        }
      },

      updateActiveToc() {
        const headerOffset = root.matchMedia('(min-width: 1024px)').matches ? 164 : 20;
        let activeIndex = this.tocTargets.findIndex(Boolean);

        this.tocTargets.forEach((heading, index) => {
          if (heading && heading.getBoundingClientRect().top <= headerOffset + 2) {
            activeIndex = index;
          }
        });

        if (activeIndex >= 0) {
          this.activeTocIndex = activeIndex;
        }
      }
    };
  }

  function registerArticleDetail() {
    if (!root.Alpine) {
      return;
    }

    root.Alpine.data('articleDetail', createArticleDetail);
  }

  if (root.Alpine) {
    registerArticleDetail();
  } else {
    root.document.addEventListener('alpine:init', registerArticleDetail, { once: true });
  }
})();
